import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as salesCatalystActions from '../../../actions/salesCatalystActions';
import SalesCatalystSectionBottom from '../SalesCatalystSectionBottom';
import CommonDropdown from '../../common/CommonDropdown';
import { SC_COMPETITORS_COMPARISON,
  SC_COMPETITORS_COMPARISON_SEL_OPTIONS, STRENGTHS, WEAKNESSESS } from '../../../constants';
import { splitLabel, checkItemAvailableInList } from '../../../util/SalesCatalystUtils';
import SalesCatalystComparisonTableGraph from './SalesCatalystComparisonTableGraph';
import Modal from '../../common/Modal/Modal';
import closePopupIcon from '../../../images/close-drawer-icon_default.png';


const modalConfigurationStyle = {
  width: '70%',
  left: '30%',
  top: '0',
  bottom: '0',
  margin: '0',
  borderRadius: '0',
  animation: 'animateLftToRgt 1s 1',
  WebkitAnimation: 'animateLftToRgt 1s 1',
};

class SalesCatalystCompetitionComparisonTable extends Component {
  constructor(props) {
    super(props);
    const { strengthsWeaknessesList: { strengths, weaknesses },
      selectedListOptions: { strengthsListDefault, weaknessesListDefault, activitiesListDefaults },
      activitiesListData,
    } = this.props;
    const swCommonList = [...strengths, ...weaknesses];
    const strengthItemAvailable = checkItemAvailableInList(swCommonList, strengthsListDefault);
    const weaknessItemAvailable = checkItemAvailableInList(swCommonList, weaknessesListDefault);
    this.state = {
      expandActivitiesHeader: '',
      expandCombineHeader: '',
      blockIndex: 0,
      expandGraphType: '',
      expandModeData: [],
      strengthsList: swCommonList,
      weaknessesList: swCommonList,
      strengthsGraphData: this.createStrengthsWeaknessesGraphData(
        strengthItemAvailable ?
        strengths[0] : strengthsListDefault),
      weaknessesGraphData: this.createStrengthsWeaknessesGraphData(
        weaknessItemAvailable ?
        weaknesses[0] : weaknessesListDefault),
      selectedOptions: {
        strengthsListDefault: !strengthItemAvailable ?
          strengthsListDefault : strengths[0],
        weaknessesListDefault: !weaknessItemAvailable ?
          weaknessesListDefault : weaknesses[0],
        activitiesListDefaults: _.map(activitiesListDefaults,
          (o, i) => o !== undefined ? o : activitiesListData[i]
        ),
      },
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { data, strengthsWeaknessesList, selectedListOptions, activitiesListData } = this.props;
    const { selectedOptions } = this.state;
    if (strengthsWeaknessesList !== nextProps.strengthsWeaknessesList) {
      const { strengths, weaknesses } = nextProps.strengthsWeaknessesList;
      const swCmnList = [...strengths, ...weaknesses];
      this.setState({
        strengthsList: swCmnList,
        weaknessesList: swCmnList,
      });
    }
    if (data !== nextProps.data) {
      this.setState({
        strengthsGraphData: this.createStrengthsWeaknessesGraphData(
          selectedOptions.strengthsListDefault, nextProps.data),
        weaknessesGraphData: this.createStrengthsWeaknessesGraphData(
          selectedOptions.weaknessesListDefault, nextProps.data),
      });
    }
    if (selectedListOptions.activitiesListDefaults !==
      nextProps.selectedListOptions.activitiesListDefaults) {
      const { activitiesListDefaults } = nextProps.selectedListOptions;
      this.setState({
        selectedOptions: { ...selectedOptions,
          activitiesListDefaults: _.map(activitiesListDefaults,
            (o, i) => o !== undefined ? o : activitiesListData[i]
          ),
        },
      });
    }
  }

  dropdownClickFn = (data, index) => {
    this.props.getDataFn(SC_COMPETITORS_COMPARISON, data.label,
      undefined, index);
    const tempList = _.clone(this.state.selectedOptions.activitiesListDefaults);
    tempList[index] = data;
    const key = _.keys(SC_COMPETITORS_COMPARISON_SEL_OPTIONS)[0];
    this.props.salesCatalystActions.setCompetitionData(
      tempList,
      key,
      SC_COMPETITORS_COMPARISON_SEL_OPTIONS[key][2],
    );
  }

  swDropdownClickFn = (data, type) => {
    const ddType = type;
    const key = _.keys(SC_COMPETITORS_COMPARISON_SEL_OPTIONS)[0];
    let objIndex = 0;
    this.setState({
      swCurrentSelectLabel: data.value,
    });
    if (ddType === 'Strengths') {
      this.setState({
        strengthsGraphData: this.createStrengthsWeaknessesGraphData(data),
        selectedOptions: { ...this.state.selectedOptions,
        strengthsListDefault: data,
        },
      });
    } else {
      objIndex = 1;
      this.setState({
        weaknessesGraphData: this.createStrengthsWeaknessesGraphData(data),
        selectedOptions: { ...this.state.selectedOptions,
          weaknessesListDefault: data,
        },
      });
    }

    this.props.salesCatalystActions.setCompetitionData(
      data,
      key,
      SC_COMPETITORS_COMPARISON_SEL_OPTIONS[key][objIndex],
    );
  }

  expandModalHeading = Mode => {
    let heading = '';
    const targetMarketLabel = this.props.targetMarket.length > 0 ?
    `${splitLabel(this.props.targetMarket[0].label)}` : '';
    const combine = 'AND';
    let competitorLabel = '';
    if (_.lowerCase(Mode) === STRENGTHS) {
      competitorLabel = this.state.selectedOptions.strengthsListDefault !== undefined ?
      splitLabel(this.state.selectedOptions.strengthsListDefault.value) : '';
    } else {
      competitorLabel = this.state.selectedOptions.weaknessesListDefault !== undefined ?
      splitLabel(this.state.selectedOptions.weaknessesListDefault.value) : '';
    }
    heading = `${targetMarketLabel} ${combine} ${competitorLabel}`;
    return heading;
  }


  createStrengthsWeaknessesGraphData = (selItem, newData) => {
    const { data } = this.props;
    const dataObj = newData !== undefined ? newData : data;
    if (selItem !== undefined) {
      const splitSelItem = selItem.label.split(' - ');
      const findItemIndex = _.findIndex(dataObj[0].groups, o => splitLabel(o) === splitSelItem[1]);
      const graphData = _.map(dataObj, o => {
        return o.activities !== undefined && o.activities.details[findItemIndex] !== undefined ?
          o.activities.details[findItemIndex][_.lowerCase(splitSelItem[0])] : [];
      });
      return graphData;
    }
    return [];
  }

  comparisonTableGraphExpandFn = (data, expandGraphType, blockIndex) => {
    const activitiesHeader = this.expandGraphActivitiesExpandFn(blockIndex);
    const combineHeader = this.expandModalHeading(expandGraphType);
    this.setState({ expandModeData: data,
                   expandGraphType,
                   blockIndex,
                   expandActivitiesHeader: activitiesHeader,
                   expandCombineHeader: combineHeader,
                  });
    this.competionTableGraphModel.show();
  }

  expandGraphActivitiesExpandFn = blockIndex => {
    const { activitiesListDefaults } = this.state.selectedOptions;
    if (activitiesListDefaults !== undefined) {
      const heading = activitiesListDefaults[blockIndex] !== 'undefined' ?
      activitiesListDefaults[blockIndex].value : '';
      return heading;
    }
    return null;
  }

  closePopupFn = () => {
    this.competionTableGraphModel.hide();
  }

  render() {
    const { activitiesListData } = this.props;
    const { strengthsList, weaknessesList, selectedOptions,
      strengthsGraphData, weaknessesGraphData, expandCombineHeader, expandActivitiesHeader } = this.state;
    return (
      <div className="sc-competition-block-section">
         <Modal
           title=""
           ref={node => (this.competionTableGraphModel = node)}
           dialogStyles={modalConfigurationStyle}
           headerStyles={{ display: 'none' }}
           isDragDisabled
           normalize
         >
          <div className="coparison-table-expand-graph">
            <button className="sc-cs-close expand-close" onClick={() => this.closePopupFn()}>
              <img className="sc-icon-img-sm" src={closePopupIcon} alt="close" />
            </button>
            <div className="row">
            {this.state.expandGraphType === STRENGTHS &&
             <div>
              {selectedOptions.strengthsListDefault !== undefined &&
             <div className="row expandModalHeading"><p className="expandModalHeading">{selectedOptions.strengthsListDefault.label}</p></div>
              }
             </div>
           }
             {this.state.expandGraphType !== STRENGTHS &&
             <div>
            {selectedOptions.weaknessesListDefault !== undefined &&
             <div className="row expandModalHeading"><p className="expandModalHeading">{selectedOptions.weaknessesListDefault.label}</p></div>
            }
             </div>
             }
              <div className="row expandModalHeading activities"><p className="combineLabel">{expandCombineHeader}</p></div>
              <div className="row expandModalHeading activities"><p className="expand-modal-activities">{expandActivitiesHeader}</p></div>
              <div className="row expand-modal-graphHeight" id="expandGraphTableContainer">
                <SalesCatalystComparisonTableGraph
                  data={this.state.expandModeData}
                  graphType={this.state.expandGraphType} expandMode="true"
                />
              </div>
            </div>
         </div>
        </Modal>

        <div className="text-align-center margin-bottom-15 clearfix">
          <h3 className="section-heading">Strengths &amp; Weaknesses</h3>
        </div>
        <div>
          <div className="row">
            <div className="small-4 columns">&nbsp;</div>
            <div className="small-4 columns">
              <CommonDropdown
                listData={strengthsList}
                defaultSelected={selectedOptions.strengthsListDefault}
                itemClickFn={data => this.swDropdownClickFn(data, 'Strengths')}
              />
            </div>
            <div className="small-4 columns">
              <CommonDropdown
                listData={weaknessesList}
                defaultSelected={selectedOptions.weaknessesListDefault}
                itemClickFn={data => this.swDropdownClickFn(data, 'Weaknesses')}
              />
            </div>
          </div>
          <div className="row margin-top-10">
            <div className="small-4 columns">
              <div className="sc-competition-ct-dd">
                <CommonDropdown
                  listData={activitiesListData}
                  defaultSelected={selectedOptions.activitiesListDefaults[0]}
                  itemClickFn={item => { this.dropdownClickFn(item, 0); }}
                />
              </div>
            </div>
            <div className="small-4 columns">
              <div className="comparision-table-block">
              {strengthsGraphData[0] && strengthsGraphData[0].length > 0 &&
                  <div className="compGraphExpandIcon">
                  <span
                    className="cs-expand-icon sc-icon-img-sm"
                    onClick={() => this.comparisonTableGraphExpandFn(strengthsGraphData[0],
                      STRENGTHS, 0)}
                  /></div>
                }
                <div className="row" id="graphTableContainer">
                  <SalesCatalystComparisonTableGraph
                    graphType={STRENGTHS}
                    data={strengthsGraphData[0]}
                  />
                </div>
              </div>
            </div>
            <div className="small-4 columns">
              <div className="comparision-table-block">
              {weaknessesGraphData[0] && weaknessesGraphData[0].length > 0 &&
              <div className="compGraphExpandIcon">
                  <span
                    className="sc-icon-img-sm cs-expand-icon"
                    onClick={() => this.comparisonTableGraphExpandFn(weaknessesGraphData[0],
                      WEAKNESSESS, 0)}
                  />
                  </div>
              }
                <div className="row" id="graphTableContainer">
                  <SalesCatalystComparisonTableGraph data={weaknessesGraphData[0]} />
                </div>
              </div>
            </div>
          </div>
          <div className="row margin-top-10">
            <div className="small-4 columns">
              <div className="sc-competition-ct-dd">
                <CommonDropdown
                  listData={activitiesListData}
                  defaultSelected={selectedOptions.activitiesListDefaults[1]}
                  itemClickFn={item => { this.dropdownClickFn(item, 1); }}
                />
              </div>
            </div>
            <div className="small-4 columns">
              <div className="comparision-table-block">
              {strengthsGraphData[1] && strengthsGraphData[1].length > 0 &&
              <div className="compGraphExpandIcon">
              <span
                className="sc-icon-img-sm cs-expand-icon"
                onClick={() => this.comparisonTableGraphExpandFn(strengthsGraphData[1],
                  STRENGTHS, 1)}
              /></div>
              }
                <div className="row" id="graphTableContainer">
                  <SalesCatalystComparisonTableGraph
                    graphType="strengths"
                    data={strengthsGraphData[1]}
                  />
                </div>
              </div>
            </div>
            <div className="small-4 columns">
              <div className="comparision-table-block">
              {weaknessesGraphData[1] && weaknessesGraphData[1].length > 0 &&
              <div className="compGraphExpandIcon">
              <span
                className="sc-icon-img-sm cs-expand-icon"
                onClick={() => this.comparisonTableGraphExpandFn(weaknessesGraphData[1],
                  WEAKNESSESS, 1)}
              /></div>
              }
                <div className="row" id="graphTableContainer">
                  <SalesCatalystComparisonTableGraph data={weaknessesGraphData[1]} />
                </div>
              </div>
            </div>
          </div>
          <div className="row margin-top-10">
            <div className="small-4 columns">
              <div className="sc-competition-ct-dd">
                <CommonDropdown
                  listData={activitiesListData}
                  defaultSelected={selectedOptions.activitiesListDefaults[2]}
                  itemClickFn={item => { this.dropdownClickFn(item, 2); }}
                />
              </div>
            </div>
            <div className="small-4 columns">
              <div className="comparision-table-block">
              {strengthsGraphData[2] && strengthsGraphData[2].length > 0 &&
              <div className="compGraphExpandIcon">
              <span
                className="sc-icon-img-sm cs-expand-icon"
                onClick={() => this.comparisonTableGraphExpandFn(strengthsGraphData[2],
                  STRENGTHS, 2)}
              /></div>
              }
                <div className="row" id="graphTableContainer">
                  <SalesCatalystComparisonTableGraph graphType="strengths"
                    data={strengthsGraphData[2]}
                  />
                </div>
              </div>
            </div>
            <div className="small-4 columns">
            <div className="comparision-table-block">
            {weaknessesGraphData[2] && weaknessesGraphData[2].length > 0 &&
              <div className="compGraphExpandIcon">
              <span
                className="sc-icon-img-sm cs-expand-icon"
                onClick={() => this.comparisonTableGraphExpandFn(weaknessesGraphData[2],
                  WEAKNESSESS, 2)}
              /></div>
              }
                <div className="row" id="graphTableContainer">
                  <SalesCatalystComparisonTableGraph data={weaknessesGraphData[2]} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <SalesCatalystSectionBottom />
        </div>
      </div>
    );
  }
}

SalesCatalystCompetitionComparisonTable.propTypes = {
  data: PropTypes.shape({}),
  getDataFn: PropTypes.func,
  selectedListOptions: PropTypes.shape({}),
  expandModalHeading: PropTypes.func,
  activitiesListData: PropTypes.arrayOf(PropTypes.shape({})),
};

function mapStateToProps(state) {
  return {
    selectedListOptions: state.salesCatalyst.scCompetition.selectedOptions,
    competitor: state.salesCatalyst.dataSelection.competitor,
    targetMarket: state.salesCatalyst.dataSelection.targetMarket,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    salesCatalystActions: bindActionCreators(salesCatalystActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SalesCatalystCompetitionComparisonTable);

